// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Dto
import { DeathDetailDto } from 'app/_mapper/deathdetail.dto';
import { DiagnoseDetailDto } from 'app/_mapper/diagnosedetail.dto';
import { DraftCallbackDetailDto } from 'app/_mapper/draftcallbackdetail.dto';
import { GeneralDetailDto } from 'app/_mapper/generaldetail.dto';

export class CaseDetailDto {
    @AutoMap() deathDetail: DeathDetailDto;
    @AutoMap() diagnoseDetail: DiagnoseDetailDto;
    @AutoMap() generalDetail: GeneralDetailDto;
    @AutoMap() draftCallbackDetail: DraftCallbackDetailDto;
}